export const WIZARD_STEPS = ['files', 'folder'] as const

export type WizardStepId = (typeof WIZARD_STEPS)[number]

export const WIZARD_LAST_STEP = WIZARD_STEPS.length - 1
